module.exports = __webpack_public_path__ + "6b93f3c6ae86fb14060ffa35ad5f3613.svg";